import { SvgIcon, SvgIconProps } from '@mui/material'

const CallOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M19.44 13c-.22 0-.45-.07-.67-.12-.45-.1-.88-.23-1.31-.39a2 2 0 0 0-2.48 1l-.22.45a12.18 12.18 0 0 1-4.66-4.66l.42-.28a2 2 0 0 0 1-2.48 10.32 10.32 0 0 1-.51-1.99 3 3 0 0 0-3-2.49h-3a3 3 0 0 0-3 3.41 19 19 0 0 0 16.52 16.46h.38a3 3 0 0 0 3-3.01v-3a3 3 0 0 0-2.47-2.9Zm.5 6a1 1 0 0 1-.72.96c-.14.05-.3.06-.44.04A17 17 0 0 1 4.07 5.22a1.09 1.09 0 0 1 .25-.82 1 1 0 0 1 .75-.34h3a1 1 0 0 1 1 .79 10.84 10.84 0 0 0 .61 2.36l-1.4.65a1 1 0 0 0-.49 1.33 14.49 14.49 0 0 0 7 7c.24.1.52.1.76 0a1 1 0 0 0 .57-.52l.62-1.4a13.73 13.73 0 0 0 2.39.61 1 1 0 0 1 .79 1l.02 3.12Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default CallOutlinedIcon
